import AttackBoxToTargetMachineSvg from 'src/images/svgs/virtual-environment/attack-box-to-target-machine.svg';
import TargetMachineSvg from 'src/images/svgs/virtual-environment/target-machine.svg';
const SUBTITLES = {
  complete: 'All machine details can be found at the top of the page.',
  taskOnly: "To successfully complete this room, you'll need to set up your virtual environment. This involves starting the Task Machine, ensuring you're equipped with the necessary tools and access to tackle the challenges ahead.",
  both: `To successfully complete this room, you'll need to set up your virtual environment. This involves starting both your AttackBox (if you're not using your VPN) and Task Machines, ensuring you're equipped with the necessary tools and access to tackle the challenges ahead.`
} as const;
export const getSubtitle = (isSetupComplete: boolean, isAttackBoxAvailable: boolean) => {
  if (isSetupComplete) {
    return SUBTITLES.complete;
  }
  return isAttackBoxAvailable ? SUBTITLES.both : SUBTITLES.taskOnly;
};
export const getImageSource = (isAttackBoxAvailable: boolean) => {
  if (!isAttackBoxAvailable) {
    return TargetMachineSvg;
  }
  return AttackBoxToTargetMachineSvg;
};